import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="topo-dark w-full border-y-4 border-ember bg-forest-deep" data-id="element-44" data-mp="1zyh2w7skw2x2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-45" data-mp="1uxjq6aqc812y">
        <h2 className="trail-underline font-display text-[30px] leading-tight text-paper sm:text-5xl" data-id="element-46" data-mp="1pz8cfowx96fg">
          Stop winging troop night.{' '}
          <span className="text-ember" data-id="element-47" data-mp="1l0yi1gj0u9uw">Walk in ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-paper/80" data-id="element-48" data-mp="1g8wyranfrivd">
          A full year of ready-to-run meetings and outdoor skills sessions your
          group will actually look forward to — even if you&apos;re not an
          outdoors expert and only have 10 minutes to prep.
        </p>

        <div className="mt-7" data-id="element-49" data-mp="12a719twpfh6h">
          <Countdown size="sm" tone="dark" data-id="element-50" data-mp="128cj2ncti363" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ember bg-ember/10 px-5 py-4 text-left" data-id="element-51" data-mp="xaucv4q6q21s">
          <div data-id="element-52" data-mp="3vdbypuyfi6kj">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-ember" data-id="element-53" data-mp="40r2fgnrky46">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-paper" data-id="element-54" data-mp="3liadha79xon8">
              Troop Night Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-55" data-mp="i0inu2gm1gs7">
            <span className="text-[15px] text-paper/60 line-through" data-id="element-56" data-mp="i11v8p8mwmrz">$69</span>
            <span className="font-display text-4xl leading-none text-paper" data-id="element-57" data-mp="myk64l67pc2m">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-58" data-mp="84f9zzcebtpf">
          <CtaButton data-id="element-59" data-mp="d0mi9ys9lhaj">Yes, I want my year planned — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-60" data-mp="2sstkobfqs5qh">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-61" data-mp="148o2xm3pagep">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-62" data-mp="14b0gln2fe4ly" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}